const routes = [
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    // the orders list answers on /, /admin and /admin/orders; meta.ordersList marks
    // all three so the layout doesn't have to compare paths
    children: [{ path: '', component: () => import('@/pages/Order/List.vue'), meta: { ordersList: true } }],
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('@/pages/Order/List.vue'), meta: { ordersList: true } },
      { path: 'dashboard', component: () => import('@/pages/Dashboard.vue') },
      { path: 'orders', component: () => import('@/pages/Order/List.vue'), meta: { ordersList: true } },
      { path: 'orders/require-refund', component: () => import('@/pages/Order/RequireRefund.vue') },
      { path: 'orders/create', component: () => import('@/pages/Order/Form.vue') },
      { path: 'orders/edit/:id', component: () => import('@/pages/Order/Form.vue') },
      { path: 'pos', component: () => import('@/pages/Waiter/Pos.vue') },
      { path: 'reports/orders', component: () => import('@/pages/Report/Orders.vue') },
      { path: 'reports/orders/list', component: () => import('@/pages/Report/OrdersList.vue') },
      { path: 'reports/response-time', component: () => import('@/pages/Report/ResponseTime.vue') },
      { path: 'reports/google-analytics', component: () => import('@/pages/Report/GoogleAnalytics.vue') },
      { path: 'reports/heatmap', component: () => import('@/pages/Report/Heatmap.vue') },
      { path: 'reports/products', component: () => import('@/pages/Report/Products.vue') },
      { path: 'reports/qr-code', component: () => import('@/pages/Report/QRCode.vue') },
      { path: 'reports/loyalty-receipts', component: () => import('@/pages/Report/LoyaltyReceipts.vue') },
      { path: 'reports/sms-sent', component: () => import('@/pages/Report/SmsSent.vue') },
      { path: 'reports/account-creation', component: () => import('@/pages/Report/AccountCreation.vue') },
      { path: 'menu/import', component: () => import('@/pages/Menu/Import.vue') },
      { path: 'menu/products', component: () => import('@/pages/Menu/Product/List.vue') },
      { path: 'menu/products/pricing', component: () => import('@/pages/Menu/Product/Pricing.vue') },
      { path: 'menu/products/import', component: () => import('@/pages/Menu/Product/Import.vue') },
      { path: 'menu/products/create', component: () => import('@/pages/Menu/Product/Form.vue') },
      { path: 'menu/products/edit/:id', component: () => import('@/pages/Menu/Product/Form.vue') },
      { path: 'menu/modifiers', component: () => import('@/pages/Menu/Modifier/List.vue') },
      { path: 'menu/modifiers/create', component: () => import('@/pages/Menu/Modifier/Form.vue') },
      { path: 'menu/modifiers/edit/:id', component: () => import('@/pages/Menu/Modifier/Form.vue') },
      { path: 'menu/categories', component: () => import('@/pages/Menu/Category/List.vue') },
      { path: 'menu/categories/create', component: () => import('@/pages/Menu/Category/Form.vue') },
      { path: 'menu/categories/edit/:id', component: () => import('@/pages/Menu/Category/Form.vue') },
      { path: 'menu/menus', component: () => import('@/pages/Menu/Menu/List.vue') },
      { path: 'menu/menus/create', component: () => import('@/pages/Menu/Menu/Form.vue') },
      { path: 'menu/menus/edit/:id', component: () => import('@/pages/Menu/Menu/Form.vue') },
      { path: 'clients', component: () => import('@/pages/Client/List.vue') },
      { path: 'clients/create', component: () => import('@/pages/Client/Form.vue') },
      { path: 'clients/edit/:id', component: () => import('@/pages/Client/Form.vue') },
      { path: 'clients/show/:id', component: () => import('@/pages/Client/Show.vue') },
      { path: 'settings/store-events', component: () => import('@/pages/Settings/StoreEvents/List.vue') },
      { path: 'settings/store-events/create', component: () => import('@/pages/Settings/StoreEvents/Form.vue') },
      { path: 'settings/store-events/edit/:id', component: () => import('@/pages/Settings/StoreEvents/Form.vue') },
      { path: 'settings/restaurant-jobs', component: () => import('@/pages/Settings/RestaurantJobs/List.vue') },
      { path: 'settings/restaurant-jobs/create', component: () => import('@/pages/Settings/RestaurantJobs/Form.vue') },
      { path: 'settings/restaurant-jobs/edit/:id', component: () => import('@/pages/Settings/RestaurantJobs/Form.vue') },
      { path: 'settings/banners', component: () => import('@/pages/Settings/Banner/List.vue') },
      { path: 'settings/banners/create', component: () => import('@/pages/Settings/Banner/Form.vue') },
      { path: 'settings/banners/edit/:id', component: () => import('@/pages/Settings/Banner/Form.vue') },
      { path: 'settings/vouchers', component: () => import('@/pages/Settings/Voucher/List.vue') },
      { path: 'settings/vouchers/create', component: () => import('@/pages/Settings/Voucher/Form.vue') },
      { path: 'settings/vouchers/edit/:id', component: () => import('@/pages/Settings/Voucher/Form.vue') },
      { path: 'settings/discounts', component: () => import('@/pages/Settings/Discount/List.vue') },
      { path: 'settings/discounts/create', component: () => import('@/pages/Settings/Discount/Form.vue') },
      { path: 'settings/discounts/edit/:id', component: () => import('@/pages/Settings/Discount/Form.vue') },
      { path: 'settings/delivery-areas', component: () => import('@/pages/Settings/DeliveryArea/List.vue') },
      { path: 'settings/delivery-areas/create', component: () => import('@/pages/Settings/DeliveryArea/Form.vue') },
      { path: 'settings/delivery-areas/one-map', component: () => import('@/pages/Settings/DeliveryArea/OneMap.vue') },
      { path: 'settings/delivery-areas/edit/:id', component: () => import('@/pages/Settings/DeliveryArea/Form.vue') },
      {
        path: 'settings/new-order-notifications',
        component: () => import('@/pages/Settings/NewOrderNotification/List.vue')
      },
      {
        path: 'settings/new-order-notifications/create',
        component: () => import('@/pages/Settings/NewOrderNotification/Form.vue')
      },
      {
        path: 'settings/new-order-notifications/edit/:id',
        component: () => import('@/pages/Settings/NewOrderNotification/Form.vue')
      },
      { path: 'settings/pages', component: () => import('@/pages/Settings/Page/List.vue') },
      { path: 'settings/pages/Create', component: () => import('@/pages/Settings/Page/Form.vue') },
      { path: 'settings/pages/edit/:id', component: () => import('@/pages/Settings/Page/Form.vue') },
      { path: 'settings/stores', component: () => import('@/pages/Settings/Store/List.vue') },
      { path: 'settings/stores/create', component: () => import('@/pages/Settings/Store/Form.vue') },
      { path: 'settings/stores/edit/:id', component: () => import('@/pages/Settings/Store/Form.vue') },
      {
        path: 'settings/stores/social-media-accounts/:id',
        component: () => import('@/pages/Settings/Store/SocialMediaAccounts.vue')
      },
      {
        path: 'settings/stores/preparation-time/:id',
        component: () => import('@/pages/Settings/Store/PreparationTime.vue')
      },
      {
        path: 'settings/stores/payment-methods/:id',
        component: () => import('@/pages/Settings/Store/PaymentMethods.vue')
      },
      { path: 'settings/channels', component: () => import('@/pages/Settings/Channel/Index.vue') },
      { path: 'settings/channels/website', component: () => import('@/pages/Settings/Channel/Website/Index.vue') },
      {
        path: 'settings/channels/website/settings',
        component: () => import('@/pages/Settings/Channel/Website/Settings.vue')
      },
      {
        path: 'settings/channels/website/tracking',
        component: () => import('@/pages/Settings/Channel/Website/Tracking.vue')
      },
      {
        path: 'settings/channels/website/design',
        component: () => import('@/pages/Settings/Channel/Website/Design.vue')
      },
      { path: 'settings/channels/phone', component: () => import('@/pages/Settings/Channel/Phone.vue') },
      { path: 'settings/channels/facebook', component: () => import('@/pages/Settings/Channel/Facebook.vue') },
      { path: 'settings/company', component: () => import('@/pages/Settings/Company.vue') },
      { path: 'settings/localization', component: () => import('@/pages/Settings/Localization.vue') },
      { path: 'settings/users', component: () => import('@/pages/Settings/User/List.vue') },
      { path: 'settings/users/create', component: () => import('@/pages/Settings/User/Form.vue') },
      { path: 'settings/users/edit/:id', component: () => import('@/pages/Settings/User/Form.vue') },
      { path: 'settings/notifications', component: () => import('@/pages/Settings/Notification/List.vue') },
      { path: 'settings/notifications/create', component: () => import('@/pages/Settings/Notification/Form.vue') },
      { path: 'settings/notifications/edit/:id', component: () => import('@/pages/Settings/Notification/Form.vue') },
      { path: 'settings/billing', component: () => import('@/pages/Settings/Billing/Info.vue') },
      { path: 'settings/billing/pay', component: () => import('@/pages/Settings/Billing/Pay.vue') },
      { path: 'settings/integrations', component: () => import('@/pages/Settings/Integration/Index.vue') },
      { path: 'settings/integrations/menu-sync', component: () => import('@/pages/Settings/Integration/MenuSync.vue') },
      {
        path: 'settings/integrations/delivery/glovo-on-demand',
        component: () => import('@/pages/Settings/Integration/Delivery/GlovoOnDemand.vue')
      },
      {
        path: 'settings/integrations/marketing/mailchimp',
        component: () => import('@/pages/Settings/Integration/Marketing/Mailchimp.vue')
      },
      {
        path: 'settings/integrations/third-party-ordering/tazz',
        component: () => import('@/pages/Settings/Integration/ThirdPartyOrdering/Tazz.vue')
      },
      {
        path: 'settings/integrations/third-party-ordering/wolt',
        component: () => import('@/pages/Settings/Integration/ThirdPartyOrdering/Wolt.vue')
      },
      {
        path: 'settings/integrations/third-party-ordering/bolt',
        component: () => import('@/pages/Settings/Integration/ThirdPartyOrdering/Bolt.vue')
      },
      {
        path: 'settings/integrations/third-party-ordering/glovo',
        component: () => import('@/pages/Settings/Integration/ThirdPartyOrdering/Glovo.vue')
      },
      {
        path: 'settings/integrations/pos/rkeeper',
        component: () => import('@/pages/Settings/Integration/Pos/Rkeeper.vue')
      },
      {
        path: 'settings/integrations/pos/ebriza',
        component: () => import('@/pages/Settings/Integration/Pos/Ebriza.vue')
      },
      {
        path: 'settings/integrations/pos/foodos',
        component: () => import('@/pages/Settings/Integration/Pos/FoodOS.vue')
      },
      {
        path: 'settings/integrations/pos/vectron',
        component: () => import('@/pages/Settings/Integration/Pos/Vectron.vue')
      },
      {
        path: 'settings/integrations/pos/rezosoft',
        component: () => import('@/pages/Settings/Integration/Pos/RezoSoft.vue')
      },
      {
        path: 'settings/integrations/pos/syrve',
        component: () => import('@/pages/Settings/Integration/Pos/Syrve.vue')
      },
      {
        path: 'settings/integrations/social-login/facebook',
        component: () => import('@/pages/Settings/Integration/SocialLogin/Facebook.vue')
      },
      {
        path: 'settings/integrations/social-login/google',
        component: () => import('@/pages/Settings/Integration/SocialLogin/Google.vue')
      },
      {
        path: 'settings/integrations/social-login/apple',
        component: () => import('@/pages/Settings/Integration/SocialLogin/Apple.vue')
      },
      { path: 'settings/integrations/pos/freya', component: () => import('@/pages/Settings/Integration/Pos/Freya.vue') },
      {
        path: 'settings/integrations/pos/freya-import',
        component: () => import('@/pages/Settings/Integration/Pos/FreyaImport.vue')
      },
      { path: 'settings/loyalty', component: () => import('@/pages/Settings/Loyalty/Configuration.vue') },
      { path: 'settings/digital-menu', component: () => import('@/pages/Settings/DigitalMenu/Configuration.vue') },
      { path: 'settings/advanced', component: () => import('@/pages/Settings/Advanced.vue') },
      { path: 'settings/meta-tags', component: () => import('@/pages/Settings/MetaTag/List.vue') },
      { path: 'settings/meta-tags/create', component: () => import('@/pages/Settings/MetaTag/Form.vue') },
      { path: 'settings/meta-tags/edit/:id', component: () => import('@/pages/Settings/MetaTag/Form.vue') },
      { path: 'profile', component: () => import('@/pages/Settings/User/Profile.vue') },
      { path: 'notifications', component: () => import('@/pages/Settings/User/Notifications.vue') },
      { path: 'start', component: () => import('@/pages/Start.vue') },
      { path: 'help', component: () => import('@/pages/Help.vue') },
      {
        path: 'settings/integrations/ai/knowledge-base',
        component: () => import('@/pages/Settings/Integration/AI/KnowledgeBase.vue')
      }
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/auth',
    component: () => import('@/layouts/Authentication.vue'),
    children: [
      { path: 'login', component: () => import('@/pages/Authentication/Login.vue') },
      { path: 'sso', component: () => import('@/pages/Authentication/SsoLogin.vue') },
      { path: 'register', component: () => import('@/pages/Authentication/Register.vue') },
      { path: 'reset-password', component: () => import('@/pages/Authentication/ResetPassword.vue') },
      { path: 'new-password/:id', component: () => import('@/pages/Authentication/NewPassword.vue') }
    ]
  },
  {
    path: '/:catchAll(.*)*',
    component: () => import('@/pages/Error404.vue')
  }
]

export default routes
